<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Medical Spas</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Unlock the power of precision advertising with LocalScale, where your med spa becomes the go-to destination for beauty and wellness!</p>
                        <p>At LocalScale, we understand that for med spas, visibility in your local community isn't just about being noticed—it's about building trust and attracting clients actively seeking your services.</p>
                        <p>Our targeted ad network lets you pinpoint potential clients by cities and zip codes, ensuring your marketing efforts resonate precisely where you operate.</p>
                        <p>Whether you're promoting cosmetic treatments, skin rejuvenation, body contouring, or personalized facials, LocalScale connects your spa to clients who prioritize aesthetics and self-care.</p>
                        <p>Let’s elevate your local presence and fill your booking calendar faster than ever!</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-medical-spas.png" alt="Medical Spas">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“Partnering with LocalScale was a game-changer for our med spa. We saw a noticeable increase in bookings, reaching new clients and expanding our practice in ways we hadn’t expected.”</h3>
                    <p class="testimonial-customer">– Sarah Delgado, Glow Aesthetics Med Spa</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>

    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
